import React, { useState } from "react";
import NutrientDropdown from "../shared/dropdowns/NutrientDropdown";

import { Dropdown, Button, Form } from "react-bootstrap";
import { gettext, interpolate } from "../shared/utils/legacy";
import ReportsVersionTile from "./ReportsVersionTile";
import { useMemo } from "react";
import useCroprBackbone from "../shared/hooks/useCroprBackbone";
import { availableReportType, GeometryModel } from "../shared/utils/cropr";
import { View } from "../shared/utils/legacy";
import { imagesLookup } from "./ReportLandingPage";
import excelfile from "../images/reports/excelfile.png";
import pdffile from "../images/reports/pdffile.png";
import docxfile from "../images/reports/docxfile.png";
import kmlfile from "../images/reports/kmlfile.svg";
import xmlfile from "../images/reports/xmlfile.svg";
import print from "../images/reports/print.svg";
import shapefile from "../images/reports/shapefile.svg";
import ReportConfigurationModal from "./ReportConfigurationModal";

const formatImages: { [key in string]: string } = {
  pdf: pdffile,
  xls: excelfile,
  preview: print,
  docx: docxfile,
  shp: shapefile,
  kml: kmlfile,
  xml: xmlfile,
};
interface Cropfield {
  name: string;
  id: string;
}

const Report = ({ reportType, report }: { reportType: string; report: availableReportType }) => {
  const [, cropFieldsCollection] = useCroprBackbone<GeometryModel>("cropfields");
  //TODO for some reports we could apply a default filter here:
  //-sensus: only sensus contract fields
  //-crop protection monitor: only NL fields
  const cropfields: Cropfield[] = useMemo(
    () =>
      cropFieldsCollection.map((c: GeometryModel) => {
        return { id: c.id, name: c.get("name") };
      }),
    [cropFieldsCollection]
  );
  const [active, setActive] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);

  const handleCheck = (e: string) => {
    if (active.includes(e)) {
      return setActive(active.filter((key) => key !== e));
    }
    return setActive([...active, e]);
  };

  const checkAll = () => {
    if (active.length !== searchResults.length) {
      const items: string[] = [];
      searchResults.forEach((cropfields) => {
        items.push(cropfields.id);
      });
      setActive(items);
    } else {
      setActive([]);
    }
  };

  //TODO rename
  const [searchResults, setSearchResults] = useState<Cropfield[]>([]);
  //TODO rename
  const [filter, setFilter] = useState("");

  const [activeVersionKey, setActiveVersion] = useState<string>(
    (report?.versions &&
      Object.entries(report.versions).map(([version, versionDetails]) => version)[0]) ||
      ""
  );
  const [activeFormatKey, setActiveFormat] = useState<string>(
    (report?.formats &&
      Object.entries(report.formats).map(([format, formatDetails]) => format)[0]) ||
      ""
  );
  const [downloadState, setDownloadState] = useState<string>("");
  const [downloadExtension, setDownloadExtension] = useState<string>("");
  const [downloadTaskId, setDownloadTaskId] = useState<string>("");
  // Disable button if this report needs a cropfieldselection but you dont have any cropfields.
  const [buttonDisabled, setbuttonDisabled] = useState(
    (!report.noCropFieldSelection || reportType === "pm_balance") && cropfields.length === 0
  );
  React.useEffect(() => {
    const results = cropfields.filter((cropfield) =>
      cropfield.name.toLocaleLowerCase().includes(filter)
    );
    setSearchResults(results);
  }, [cropfields, filter, setSearchResults]);
  const [title, setTitle] = useState(gettext("Search for cropfields"));
  React.useEffect(() => {
    if (active.length > 0 && active.length < 3) {
      const activeData: string[] = [];
      active.forEach((id) => {
        activeData.push(cropfields.find((cropfield) => cropfield.id === id)!.name);
      });
      setTitle(activeData.toString());
    } else if (active.length > 2) {
      const number = active.length.toString();
      setTitle(interpolate(gettext(`%s cropfields selected`), [number]));
    } else {
      setTitle(gettext("Search for cropfields"));
    }
    cropFieldsCollection.each(function (cropfield) {
      cropfield.set({ selected: active.includes(cropfield.id) });
    });
  }, [cropFieldsCollection, cropfields, active]);

  if (!report) return <></>;
  const activeFormat = report.formats[activeFormatKey];
  const activeVersion = report.versions && report.versions[activeVersionKey];

  const getDownloadStatus = (taskId: string) => {
    let refreshUrl = interpolate("/cropr/export/status/%s/json/", [taskId]);
    let state = "";
    $.ajax({
      url: refreshUrl,
      type: "GET",
      success: function (taskStatus) {
        state = taskStatus["state"];
        if (state === "SUCCESS" || state === "FAILURE") {
          setbuttonDisabled(false);
          setDownloadState(state);
          setDownloadExtension(taskStatus["extension"]);
        } else {
          setTimeout(() => {
            getDownloadStatus(taskId);
          }, 3000);
        }
      },
      error: function (response) {
        setDownloadState("FAILURE");
        setbuttonDisabled(false);
      },
    });
  };

  const printCallback = (taskId: string, done: boolean = false) => {
    if (done) return setbuttonDisabled(false); //enable button again for direct downloads
    setDownloadTaskId(taskId);
    setDownloadState("STARTED");
    getDownloadStatus(taskId);
  };
  const handleGenerate = () => {
    if (buttonDisabled) return;
    setDownloadState(""); //reset downloadstate to hide preview
    setbuttonDisabled(true);
    let key = reportType + (activeVersion?.extraKey || "") + (activeFormat?.extraKey || "");
    let track =
      (report.track || "") + (activeVersion?.extraTrack || "") + (activeFormat?.extraTrack || "");

    const exportView = new View.ExportButtonView({ model: cropFieldsCollection });
    exportView.printDebounced(key, printCallback);
    //@ts-ignore
    track && track_event("Click", track, "Subscribed"); //TODO add track_event() to cropr.ts
  };
  return (
    <>
      <div className={"nutrient-reports container-fluid"}>
        <div className={"row py-3 px-2"}>
          {/* FIXME float not allowed */}
          <div className={"col-12 col-md-4"}>
            {!report.noCropFieldSelection && (
              <>
                <h4 className={"mb-3"}>{gettext("Select cropfield")}</h4>
                <div className={"mb-3"}>
                  <Dropdown>
                    <NutrientDropdown.DropdownButton title={title} variant={"smoke"}>
                      <NutrientDropdown.CheckboxItem
                        bsPrefix={"custom-control--searchfield"}
                        id={"0"}
                        name={
                          <NutrientDropdown.Search>
                            <input
                              autoFocus={true}
                              type="text"
                              className="form-control"
                              placeholder={gettext("Search...")}
                              onChange={(event) =>
                                setFilter(event.target.value.toLocaleLowerCase())
                              }
                            />
                          </NutrientDropdown.Search>
                        }
                        onClick={() => checkAll()}
                        active={
                          active.length === searchResults.length && searchResults.length !== 0
                        }
                      />
                      {searchResults.map((data) => (
                        <NutrientDropdown.CheckboxItem
                          id={data.id}
                          key={data.id}
                          active={active.includes(data.id)}
                          onClick={() => handleCheck(data.id)}
                          name={data.name}
                        />
                      ))}
                    </NutrientDropdown.DropdownButton>
                  </Dropdown>
                </div>
              </>
            )}
            <>
              <h4 className={"mb-2"}>{gettext("Format")}</h4>
              <div className={"d-flex mb-2"}>
                {Object.entries(report.formats).map(([format, formatDetails]) => (
                  <ReportsVersionTile
                    active={activeFormatKey}
                    id={format}
                    key={format}
                    onClick={() => setActiveFormat(format)}
                    img={formatImages[format]}
                    format={format || formatDetails.description}
                  />
                ))}
              </div>
            </>
            {report.versions && (
              <>
                <h4 className={"mb-2"}>{gettext("Version")}</h4>
                <div className={"nutrient-reports__version-list mb-3"}>
                  {Object.entries(report.versions).map(([version, versionDetails]) => (
                    <Form.Check
                      type={"radio"}
                      id={version}
                      key={version}
                      value={""}
                      label={versionDetails.description || version}
                      bsCustomPrefix={
                        version === activeVersionKey
                          ? "custom-control version checked"
                          : `custom-control version`
                      }
                      checked={version === activeVersionKey}
                      onChange={(id) => setActiveVersion(version)}
                      onClick={(id) => setActiveVersion(version)}
                      custom
                    />
                  ))}
                </div>
              </>
            )}
            <div className={"mb-3"}>
              <Button
                variant={"primary"}
                onClick={() => handleGenerate()}
                disabled={buttonDisabled}
                className={"mb-1 mr-1"}
              >
                {downloadState === "STARTED" && (
                  <>
                    <i className={"far fa-spinner fa-spin mr-2"} />
                    {gettext("Creating report")}
                  </>
                )}
                {downloadState !== "STARTED" && <>{gettext("Create report")}</>}
              </Button>
              {report.config && (
                <Button
                  variant={"smoke-light"}
                  onClick={() => setShowModal(!showModal)}
                  className={"mb-1"}
                >
                  <i className={"far fa-cog"} /> {gettext("Configure")}
                </Button>
              )}
              {report.config && (
                <ReportConfigurationModal
                  show={showModal}
                  handleClose={() => setShowModal(false)}
                  configKey={report.config}
                />
              )}
            </div>
          </div>
          <div className={"col-12 col-md-8"}>
            <div
              className={"border rounded p-3 shadow-sm bg-white"}
              style={{ minWidth: "16rem", maxWidth: "32rem" }}
            >
              <div className={"row px-3"}>
                {report.icon && (
                  <div>
                    <img
                      src={imagesLookup[report.icon]}
                      alt={report.title}
                      className={"float-left mb-2 mr-2"}
                      style={{ maxHeight: "4rem", objectFit: "cover" }}
                    />
                  </div>
                )}
                <h4 className={"my-auto py-2"}>{report.title}</h4>
              </div>
              <div className={"row px-3"}>{report.description && <p>{report.description}</p>}</div>
            </div>
          </div>
        </div>
        {downloadState !== "" && (
          <div className={"row py-3 px-2"}>
            <div className={"col"}>
              {downloadState === "SUCCESS" && (
                <>
                  <h4 className={"mb-4"}>
                    <a href={`/cropr/export/download/${downloadTaskId}/`}>
                      {gettext("Download report")}
                    </a>
                  </h4>
                  {downloadExtension === "pdf" && (
                    <>
                      <object
                        data={`/cropr/export/download/${downloadTaskId}/?inline=true`}
                        type="application/pdf"
                        width="100%"
                        height="500"
                      >
                        <embed
                          src={`/cropr/export/download/${downloadTaskId}/?inline=true`}
                          type="application/pdf"
                          width="100%"
                          height="500"
                        />
                      </object>
                    </>
                  )}
                </>
              )}
              {downloadState === "FAILURE" && (
                <div className="alert alert-error">
                  {gettext("Download failed, please try later")}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Report;
